// Ensure this docNav is here to control placement in the doc nav. Is parsed out as shown in one line in generateComponentData.js
export const docNav = {
  "category": "02.Authentication",
  "position": "10"
}; // eslint-disable-line
export { default } from './ChooseProfileForm';